var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavVBitacoraActive = function SvgNavVBitacoraActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_v_bitacora_active_svg__Capa_2",
    viewBox: "0 0 30.27 34.06"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_v_bitacora_active_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.91,
    height: 32.56,
    x: 4.61,
    y: 0.75,
    rx: 4.24,
    ry: 4.24,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.21 7.76H24.7M10.21 13.94H24.7M10.21 20.12H24.7M10.21 26.3H24.7M7.22 10.46H.75M7.22 17.03H.75M7.22 23.61H.75",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavVBitacoraActive;